import { makeText, isActionAllowed } from "../../../util";

export const StackButtons = ({ dev, stack, selected, toggleStack, language, settings }) => {
  const counts = { active: 0, rejected: 0 };
  stack.categories.forEach(c => {
    if (selected === 'consent' && c.active) {
      counts.active += 1;
    } else if (selected === 'consent' && !c.active) {
      counts.rejected += 1;
    }
    if (selected === 'li' && c.legInt) {
      counts.active += 1;
    } else if (selected === 'li' && !c.legInt) {
      counts.rejected += 1;
    }
  });

  const acceptedAllText = makeText(Boolean(dev), settings, 'acceptedAllText', language);
  const rejectedAllText = makeText(Boolean(dev), settings, 'rejectedAllText', language);
  const partialConsentText = makeText(Boolean(dev), settings, 'partialConsentText', language);
  const acceptAllText = makeText(Boolean(dev), settings, 'acceptAllText', language);
  const rejectAllText = makeText(Boolean(dev), settings, 'rejectAllText', language);

  let status = partialConsentText;
  if (counts.active > 0 && counts.rejected === 0) {
    status = acceptedAllText;
  }
  if (counts.rejected > 0 && counts.active === 0) {
    status = rejectedAllText;
  }

  const statusFont = { ...settings.accordionsFont };
  delete statusFont.color;

  return (
    <div className="stack-toggles">
      <button
        tabIndex="0"
        className={status === rejectedAllText ? 'stack-toggle reject-toggle choice' : 'stack-toggle reject-toggle'}
        onClick={(e) => toggleStack(e, stack.categories, false, selected === 'li' ? true : false)}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleStack(e, stack.categories, false, selected === 'li' ? true : false)}
      >
        {rejectAllText}
      </button>
      <button
        tabIndex="0"
        className={status === acceptedAllText ? 'stack-toggle accept-toggle choice' : 'stack-toggle accept-toggle'}
        onClick={(e) => toggleStack(e, stack.categories, true, selected === 'li' ? true : false)}
        onKeyDown={(e) => isActionAllowed(e.key) && toggleStack(e, stack.categories, true, selected === 'li' ? true : false)}
      >
        {acceptAllText}
      </button>
    </div>
  );
};